import React, { useEffect, useState } from "react";
import MyButton from "components/MyButton";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory, useParams } from "react-router-dom";
import SearchComp from "components/Searchcomponent";
import FinanceService from "Lib/API/Finance";
import Tabs from "components/Tabs";
import AutoCompleteField from "components/autoCompleteField";
import MyModal from "components/MyModal";
import { SubHeader } from "layout/SubHeader";
import ProductDetailTable from "./detailsTable";
import { AddProduct } from "./addProduct";
import ArrowDSVG from "assets/icons/svg/arrow-details";
import DeactivatProducts from "./deactivatedProducts";
import { useSelector, useDispatch } from "react-redux";
import {
  addSubCategorys,
  addLedgerAccounts,
} from "pages/School/Classes/classSlice";

import "../index.scss";
import { toastr } from "react-redux-toastr";

const ProductDetails = () => {
  const enableLoading = (value) => {
    setLoading(value);
  };
  const params = useParams();
  const dispatch = useDispatch();
  const [getSub, setGetSub] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = React.useState(false);
  const { ledgerAccounts } = useSelector((state) => state?.data);
  const { subCat } = useSelector((state) => state?.data);
  const [activeTab, setActiveTab] = useState(0);
  const [searchText, setSearchText] = React.useState("");
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState({});
  const [idObject, setIdObject] = useState({});
  const [editClicked, setEditClicked] = useState(false);
  const [refresh, setRefresh] = React.useState(false);
  const history = useHistory();
  const [ledgerToAdd, setLedgerToAdd] = useState("");
  const o = history?.location?.state;
  const [ledgerValue, setLedgerValue] = useState({
    value: o?.ledgerId,
    label: o?.ledgerName,
  });
  const [subValue, setSubValue] = useState({
    value: o?.subId,
    label: o?.subName,
  });

  const style = {
    width: "200px",
    height: "45px",
    border: "none",
  };

  React.useEffect(() => {
    const object = {
      ledgerId: ledgerValue?.value,
      ledgerName: ledgerValue?.label,
      subId: subCat?.length != 0 ? subValue?.value : "",
      subName: subCat?.length != 0 ? subValue?.label : "",
    };
    if (subValue?.value || ledgerValue?.value)
      history.push(
        `/product-details/${
          subValue?.value
            ? subValue?.value
            : ledgerValue?.value
            ? ledgerValue?.value
            : ""
        }`,
        object
      );
  }, [ledgerValue, subValue]);

  useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      await FinanceService.getSubcategoriesByLedgerAccountFiltered(
        "?active=true",
        ledgerValue?.value,
        token
      )
        .then((res) => {
          if (res.length) {
            const subCat = [];
            res.map((item) => {
              subCat.push({
                value: item?._id,
                label: item?.sub_cat_name,
              });
              item.id = item._id;
              return item;
            });
            dispatch(addSubCategorys(subCat));
          } else {
            dispatch(addSubCategorys([]));
          }
          enableLoading(false);
        })
        .catch((err) => {
          dispatch(addSubCategorys([]));
          enableLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    }
    if (ledgerValue?.value) fetchMyAPI();
    enableLoading(true);
  }, [ledgerValue, ledgerToAdd]);

  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      if (ledgerAccounts.length === 0)
        await FinanceService.getLedgeraccounts("filter?active=true", token)
          .then((res) => {
            if (res.length) {
              const ledger_accounts = [];
              res.map((item) => {
                ledger_accounts.push({
                  value: item?._id,
                  label: item?.led_acc_name,
                });
                item.id = item._id;
                return item;
              });
              dispatch(addLedgerAccounts(ledger_accounts));
            }
            enableLoading(false);
          })
          .catch((err) => {
            enableLoading(false);
            toastr.error("Error", err?.data?.message);
          });
    }
    fetchMyAPI();
    enableLoading(true);
  }, [getAccessTokenSilently]);

  return (
    <div className="school-classes pr-12 pt-5">
      <div className="header">
        <div className="header-tittle">
          {(ledgerValue?.value || subValue?.value) && (
            <ArrowDSVG
              style={{ cursor: "pointer" }}
              onClick={() =>
                history.push(
                  `/sub-category/${ledgerValue?.value}`,
                  ledgerValue?.label
                )
              }
            />
          )}
          <SubHeader
            className="subheader"
            {...{
              title: `Products List ${
                subValue?.label
                  ? "-" + subValue?.label
                  : ledgerValue?.label
                  ? "-" + ledgerValue?.label
                  : ""
              }`,
            }}
          />
        </div>
        <div className="new-class">
          <MyButton
            style={{ width: "190px", height: "auto" }}
            type={"primary"}
            content={"Add Product"}
            onClick={() => {
              setEditClicked(false);
              setData({});
              setOpenModal(!openModal);
            }}
          />
        </div>
      </div>
      <div>
        <Tabs
          tabs={[
            {
              title: "Activated Products",
              content: (
                <>
                  <div className="activated-ledger">
                    <div className="sub-header-functions">
                      <div className="mr-5">
                        <AutoCompleteField
                          style={style}
                          classNamePrefix="react-select"
                          options={ledgerAccounts}
                          placeholder="Ledger Account"
                          onChange={(value) => {
                            setLedgerValue(value);
                          }}
                          defaultValue={
                            o?.ledgerName
                              ? {
                                  value: o?.ledgerId,
                                  label: o?.ledgerName,
                                }
                              : ""
                          }
                        />
                      </div>
                      <div className="mr-5">
                        <AutoCompleteField
                          style={style}
                          classNamePrefix="react-select"
                          options={subCat}
                          placeholder="Sub-Category"
                          onChange={(value) => {
                            setSubValue(value);
                          }}
                          defaultValue={
                            o?.subName
                              ? {
                                  value: o?.subId,
                                  label: o?.subName,
                                }
                              : ""
                          }
                        />
                      </div>
                      <SearchComp
                        value={searchText}
                        setSearchText={setSearchText}
                      />
                      {/* <div className="cancel-button">
                        <MyButton
                          type="secondary"
                          content={"reset"}
                          onClick={() => {}}
                        />
                      </div> */}
                    </div>
                  </div>
                  <ProductDetailTable
                    ledgerValue={ledgerValue}
                    subValue={subValue}
                    searchText={searchText}
                    setData={setData}
                    setEdit={setOpenModal}
                    setEditClicked={setEditClicked}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    setIdObject={setIdObject}
                  />
                </>
              ),
            },
            {
              title: "Deactivated Products",
              content: (
                <>
                  <div className="activated-ledger">
                    <div className="sub-header-functions">
                      <div className="mr-5">
                        <AutoCompleteField
                          style={style}
                          classNamePrefix="react-select"
                          options={ledgerAccounts}
                          placeholder="Ledger Account"
                          onChange={(value) => {
                            setLedgerValue(value);
                          }}
                          defaultValue={
                            o?.ledgerName
                              ? {
                                  value: o?.ledgerId,
                                  label: o?.ledgerName,
                                }
                              : ""
                          }
                        />
                      </div>
                      <div className="mr-5">
                        <AutoCompleteField
                          style={style}
                          classNamePrefix="react-select"
                          options={subCat}
                          placeholder="Sub-Category"
                          onChange={(value) => {
                            setSubValue(value);
                          }}
                          defaultValue={
                            o?.subName
                              ? {
                                  value: o?.subId,
                                  label: o?.subName,
                                }
                              : ""
                          }
                        />
                      </div>
                      <SearchComp
                        value={searchText}
                        setSearchText={setSearchText}
                      />
                    </div>
                  </div>
                  <DeactivatProducts
                    searchText={searchText}
                    subValue={subValue}
                    refresh={refresh}
                    setRefresh={setRefresh}
                  />
                </>
              ),
            },
          ]}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          type="secondary"
        ></Tabs>
      </div>
      <MyModal
        className="add-ledger-modal"
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      >
        <AddProduct
          setLedgerToAdd={setLedgerToAdd}
          getSub={getSub}
          setGetSub={setGetSub}
          setOpenModal={setOpenModal}
          open={openModal}
          refresh={refresh}
          setRefresh={setRefresh}
          data={data}
          editClicked={editClicked}
          idObject={idObject}
        />
      </MyModal>
    </div>
  );
};

export default ProductDetails;
